import {baseChangeRegion} from '../general/actionCreators';

import {buildURL} from './url';

export const changeRegion = id => baseChangeRegion(id, buildURL);
